import PlusCircleFill from './PlusCircleFill';

export default PlusCircleFill;
